import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
import { consultingServices, speakingTopics } from '../../data/highlights';
import type { Interest } from '../../types/contact';
type EngageSectionProps = {
  onRequestContact: (interest: Interest) => void;
};
export function EngageSection({
  onRequestContact
}: EngageSectionProps) {
  return <section aria-label="Speaking and consulting" className="bg-white" data-id="element-106" data-mp="3vhlv8ddswjvx">
      <div className="px-fluid py-section grid gap-[clamp(1.25rem,2vw,3rem)] lg:grid-cols-2" data-id="element-107" data-mp="3vf9ajsgnrvf6">
        <Reveal className="h-full" data-id="element-108" data-mp="48g3w933j439">
          <article id="speaking" aria-labelledby="speaking-heading" className="radius-fluid pad-box flex h-full flex-col bg-brand-navy text-white" data-id="element-109" data-mp="9195io39pwb4">
            <h2 id="speaking-heading" className="text-h2 font-extrabold" data-id="element-110" data-mp="i2yxbv12ax9f">
              Book David to Speak
            </h2>
            <p className="text-body-fluid mt-[clamp(1.25rem,2vw,2.25rem)] max-w-[52ch] text-white/85" data-id="element-111" data-mp="n224pm4ilfkk">
              I’ve spoken on stages in front of thousands of people across the country. I bring energy, real-world
              experience and straight talk on marketing, AI, automation and turning your life around.
            </p>
            <h3 className="sr-only" data-id="element-112" data-mp="7xj2be0tm82v">Speaking topics</h3>
            <ul className="mt-[clamp(1.75rem,2.5vw,3rem)] flex flex-wrap gap-[clamp(0.5rem,0.6vw,0.85rem)]" data-id="element-113" data-mp="2xwph5owmtul">
              {speakingTopics.map(topic => <li key={topic} className="rounded-full border border-white/25 bg-white/[0.08] px-[clamp(0.9rem,1vw,1.4rem)] py-[clamp(0.45rem,0.5vw,0.7rem)] text-small-fluid font-semibold text-white" data-id="element-114" data-mp="vlirwamebsfv">
                  {topic}
                </li>)}
            </ul>
            <div className="mt-auto pt-[clamp(2.5rem,3.5vw,4.5rem)]" data-id="element-115" data-mp="1jbwkq3ct1vbi">
              <button type="button" onClick={() => onRequestContact('Speaking')} className="btn group bg-white text-brand-navy hover:shadow-[0_10px_30px_-10px_rgba(1,159,254,0.7)]" data-id="element-116" data-mp="1ekek5gep1wr2">
                Request David for Your Event
                <ArrowRightIcon className="h-[1.1em] w-[1.1em] transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-117" data-mp="1oo1sv7paymc7" />
              </button>
            </div>
          </article>
        </Reveal>

        <Reveal delay={0.06} className="h-full" data-id="element-118" data-mp="1es8gppfhwuuy">
          <article id="consulting" aria-labelledby="consulting-heading" className="radius-fluid pad-box flex h-full flex-col border border-brand-slate/10 bg-brand-mist" data-id="element-119" data-mp="1jq05iakug0ux">
            <h2 id="consulting-heading" className="text-h2 font-extrabold text-brand-navy" data-id="element-120" data-mp="19rayjcuhk0tg">
              Work With David
            </h2>
            <p className="text-body-fluid mt-[clamp(1.25rem,2vw,2.25rem)] max-w-[52ch]" data-id="element-121" data-mp="344tr089nst7w">
              Small, focused engagements that make a real difference: where AI and automation fit in your business,
              which processes to streamline first, and how to turn that into more revenue.
            </p>
            <h3 className="sr-only" data-id="element-122" data-mp="12703ymb91z8y">Consulting services</h3>
            <ul className="mt-[clamp(1.75rem,2.5vw,3rem)] grid gap-x-8 gap-y-4 sm:grid-cols-2" data-id="element-123" data-mp="128kxq9pqpe5r">
              {consultingServices.map(service => <li key={service} className="flex items-center gap-3 text-body-fluid font-semibold text-brand-slate" data-id="element-124" data-mp="1c4o9m7ae8r5w">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-blue text-white" data-id="element-125" data-mp="175l30iermcvt">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-126" data-mp="1l5cmgyo1wlh7" />
                  </span>
                  {service}
                </li>)}
            </ul>
            <div className="mt-auto pt-[clamp(2.5rem,3.5vw,4.5rem)]" data-id="element-127" data-mp="3myabskimcvxe">
              <button type="button" onClick={() => onRequestContact('Consulting')} className="btn group bg-brand-navy text-white hover:bg-brand-blue" data-id="element-128" data-mp="3hyxm7s0d5ar4">
                Schedule a Consult
                <ArrowRightIcon className="h-[1.1em] w-[1.1em] transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-129" data-mp="3ocuxjyw55ktx" />
              </button>
            </div>
          </article>
        </Reveal>
      </div>
    </section>;
}